
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'CitiesSearch',

	methods: {
		filterCity($event: Event) {
			const target = $event.target as HTMLInputElement;
			this.$emit('onFilterCities', target.value);
		},
	},
});
